import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'AccountingMethod';
const ENDPOINT = `/accounting-methods/`;

@Injectable({
    providedIn: 'root'
})
export class AccountingMethodService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
